import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/store/auth/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  resetPassword: FormGroup | any;
  currentPassword: boolean = false
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  urlParams: any = null;
  message: String = "";
  userO = this.authService.userO;
  private userSub: Subscription;
  loginUserData: any = {};
    passwordMatched: boolean = false;


  constructor(
      private readonly fb: FormBuilder,
      private readonly authService: AuthService,
      private readonly ngxToaster: ToastrService,
      private readonly router: Router
  ) {}

  ngOnInit(): void {
      this.initResetForm();
      this.userSub = this.userO.subscribe((data) => {
        if (!data) return;
        if (data?.isData === true) {
            this.loginUserData = data?.body;
            console.log('loginDataaaaaaa' , this.loginUserData)
           
        } 
    });
  }

    //shows current visibility
    showCurrentPassFn() {
      this.currentPassword = !this.currentPassword;
  }

  //shows password visibility
  showPasswordFn() {
      this.showPassword = !this.showPassword;
  }

  //show confirm password visibility
  showConfirmPasswordFn() {
      this.showConfirmPassword = !this.showConfirmPassword;
  }

  initResetForm() {
      this.resetPassword = this.fb.group({
          oldPassword:["" , [Validators.required]],
          newPassword: ["", [Validators.required]],
          confirmPassword: ["", [Validators.required]],
      });
  }

  resetPasswordPayload() {
      const formValue = this.resetPassword.value;
      return {
         _id: this.loginUserData?._id,
         oldPassword: formValue.oldPassword,
         newPassword: formValue.newPassword,
         confirmPassword: formValue.confirmPassword,
          // ...this.urlParams,
      };
  }

  passwordMatch() {
    const newPassword = this.resetPassword.get("newPassword")?.value;
    const confirmPassword = this.resetPassword.get("confirmPassword")?.value;
    if (newPassword !== confirmPassword) {
        this.message = "Passwords do not match.";
        this.passwordMatched = false
    } else {
        this.message = "";
        this.passwordMatched = true
    }
   }

  submit() {
    this.passwordMatch()
    if (this.passwordMatched === false){
        this.message = "Passwords do not match.";
        return;
      }
      this.touchFormControls();
      if (this.resetPassword.valid) {
          this.authService
              .resetEmployerPassword(this.resetPasswordPayload())
              .subscribe({
                  next: (response: any) => {
                      console.log(response);
                      const { result, body, isData } = response;
                      if (isData === true) {
                          this.ngxToaster.success(result);
                      } else {
                          this.ngxToaster.error(result);
                      }
                  },
              });
      }
  }

  touchFormControls() {
      Object.keys(this.resetPassword.controls).forEach((key) => {
          this.resetPassword.get(key)?.markAsTouched();
      });
  }

  ngOnDestroy() {
    this.userSub.unsubscribe();
}
}
